import { useMutation } from "@tanstack/react-query";
import { deleteUserAccount } from "api/delete-user-account";

export const useDeleteAccount = () =>
  useMutation({
    mutationFn: deleteUserAccount,
  });
